export const metaData = {
  'meta-title': 'Personal finances - financial data solutions',
  'meta-description':
    "Get the full picture of your users' financial lives. With Plaid, gain access to bank transactions, continuously updated and categorized.",
};

export const pageHeaderData = {
  'content-width-classes': 'page-header-breakpoint-6 large-6',
  label: true,
  'label-text': 'Personal finances',
  header:
    'Help users improve their financial health with categorised transactions',
  'header-class': 'h2',
  subheader: null,
  'primary-cta': true,
  'primary-cta-text': 'Contact sales',
  'primary-cta-link': '#contactForm',
  'secondary-cta': false,
  'secondary-cta-text': null,
  'tertiary-cta':
    'Or, <a class="signup-attach-utm" href="//dashboard.plaid.com/signup">get started</a>',
  image: true,
  'image-width': 1140,
  'image-height': 530,
  'image-url': '/assets/img/hero/personal-finance-hero-intl.png',
  'image-classes': 'page-header-bg__img-overflow-large',
};

export const socialProofData = {
  header: 'Customers using this solution',
  alignment: 'center',
  'column-count': 4,
  'full-width': true,
  logos: [
    {
      img: '/assets/img/logos/logo-cleo-black600.png',
      alt: 'Cleo',
    },
    {
      img: '/assets/img/logos/logo-drop-black600.png',
      alt: 'Drop',
    },
    {
      img: '/assets/img/logos/logo-qapital-black600.png',
      alt: 'Qapital',
    },
    {
      img: '/assets/img/logos/logo-dave-black600.png',
      alt: 'Dave',
    },
  ],
};

export const introSectionData = {
  'problem-statement':
    "Obtaining a comprehensive picture of users' financial health is often times difficult when they have accounts at multiple financial institutions.",
  'solution-statement':
    'Plaid consolidates 2 years of financial data using PSD2 integrations. Our categorisation engine makes transaction data easy to use and analyse.',
};

export const quoteData = {
  quote:
    'Because of Plaid, we were able to scale quickly without hiring additional engineers, saving us an immense amount of costs and time.',
  'quote-logo': true,
  'quote-logo-icon': '/assets/img/logos/drop-logo.svg',
  'logo-alt': 'Drop logo',
  cite: 'Daniel Whiffing, Technical Lead at Drop',
  'quote-link': '/documents/Drop-Case-Study.pdf',
  'quote-link-text': 'See the full case study',
  'with-background': false,
  dark: false,
};

export const featureSectionData = {
  'feature-section-title': [
    {
      label: 'Products and benefits',
    },
  ],
  'feature-section-items': [
    {
      img: '/assets/img/products/intl-transactions-112@2x.png',
      title: 'Encourage users to save',
      'header-class': 'h5',
      content:
        '<a href="/eu/products/transactions">Transactions</a> helps users eliminate wasteful spending and guides users towards investment and savings goals by analysing 2 years of clean, categorised transaction history',
      'no-link': true,
    },
  ],
};

export const simpleCarouselData = {
  'carousel-title': 'How It Works',
  'carousel-slides': [
    {
      header: 'Integrate with Plaid',
      description:
        'It takes just a few lines of code to drop our front-end module into your app or digital service. Your users will be prompted to connect their bank account, which will launch the Plaid module.',
      'bg-color': 'bg-green',
      img: '/assets/img/carousel/use-cases-carousel-0.png',
    },
    {
      header: 'Customise for conversion',
      description:
        'Customise the module to fit your brand or user preferences, including which financial institutions show up first.',
      'bg-color': 'bg-blue',
      img: '/assets/img/carousel/use-cases-carousel-link-demo-1.png',
    },
    {
      header: 'Get user-permissioned bank data',
      description:
        'Once a user has gone through the flow, we do the work and return a range of relevant bank account data depending on what fits your needs.',
      'bg-color': 'bg-pink',
      img: '/assets/img/carousel/use-cases-carousel-link-demo-2.png',
    },
  ],
};

export const ctaData = {
  'marketo-key': 2007,
  title: 'Questions about how Plaid can fit into your business?',
  'with-subtext': true,
  subtext: 'Tell us how we can help and we’ll get in touch shortly.',
  'subtext-class': 'h4 regular',
  'include-phone': true,
};
